import { baseRequest } from './base'


//排班报表详情
function operationSchedulingReport(params) {
    let tempUrl = '/api/operationScheduling/operationSchedulingReport';
    return baseRequest(tempUrl, 'get',params);
}


export default {
    operationSchedulingReport
}
